import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { ChatControlButton } from "../../../ChatControlButton";
import { useLiveChatUIContext } from "../../LiveChatUIContext";
import { ReactComponent as MenuIcon } from "./assets/menu.svg";

export interface LiveChatUIMobileTopBarProps {
  endSlot: ReactNode;
  /** Whether to show the skeleton (loading state) version of the component */
  skeleton?: boolean;
  className?: string;
}

export const LiveChatUIMobileTopBar: FC<LiveChatUIMobileTopBarProps> = ({
  endSlot,
  skeleton = false,
  className,
}) => {
  const { openSidebar } = useLiveChatUIContext();

  return (
    <header
      className={cx(
        "flex shrink-0 items-center justify-between border-t-0 border-r-0 border-b border-l-0 border-solid border-grey-200 bg-white px-4 py-3 md:hidden",
        className
      )}
    >
      {skeleton ? (
        <>
          {[0, 1].map((key) => (
            <div
              key={key}
              className="flex h-10 w-10 shrink-0 animate-pulse items-center justify-center"
            >
              <div className="h-5 w-5 rounded-full bg-[#F2F2F2]" />
            </div>
          ))}
        </>
      ) : (
        <>
          <ChatControlButton
            size="lg"
            aria-label="Open sidebar"
            className="animate-fade-in"
            onClick={openSidebar}
          >
            <MenuIcon />
          </ChatControlButton>
          {endSlot}
        </>
      )}
    </header>
  );
};
